module.exports = __webpack_public_path__ + "img/Dayliner.b1d7a632.jpg";